import React from 'react';
import theme from './PasswordValidation.module.scss';
import {
    PasswordValidator,
    RequireLength,
    RequireLowercase,
    RequireUppercase,
    RequireNumber,
    IPasswordValidationRequirement,
} from '@/utils/password';
import { Trans } from '@lingui/react/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons';

const requirementTexts = {
    'min-length': (req: RequireLength) => <Trans>Be at least {req.minLength} characters long</Trans>,
    lowercase: (req: RequireLowercase) => <Trans>Have a lowercase character</Trans>,
    uppercase: (req: RequireUppercase) => <Trans>Have an uppercase character</Trans>,
    number: (req: RequireNumber) => <Trans>Have a number</Trans>,
};

interface PasswordValidationProps {
    password: string;
    validator: PasswordValidator;
}

const PasswordValidation: React.FC<PasswordValidationProps> = ({ password, validator }) => {
    const result = validator.validate(password);

    const isRequirementMet = (req: IPasswordValidationRequirement) => {
        return !result.unmetRequirements.includes(req);
    };

    return (
        <div>
            <Trans>The password must:</Trans>
            <ul className={theme.list}>
                {validator.requirements.map((x, i) => (
                    <li key={i}>
                        {isRequirementMet(x) ? (
                            <FontAwesomeIcon fixedWidth icon={faCheck} />
                        ) : (
                            <FontAwesomeIcon fixedWidth icon={faTimes} />
                        )}{' '}
                        {requirementTexts[x.type](x)}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PasswordValidation;
